<template>
  <q-layout view="hHh lpR fFf">
    <app-header />
    <q-page-container>
      <router-view />
    </q-page-container>
    <app-footer />
  </q-layout>
</template>
